/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Forms_2Inputs */

const en_pc_tut_forms_2 = /** @type {(inputs: Pc_Tut_Forms_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Add comments for sticky notes, highlights, underlines, shapes and ink.`)
};

const zh_pc_tut_forms_2 = /** @type {(inputs: Pc_Tut_Forms_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开「Add comments」添加便签、高亮、下划线、形状和手绘。`)
};

/**
* | output |
* | --- |
* | "Open Add comments for sticky notes, highlights, underlines, shapes and ink." |
*
* @param {Pc_Tut_Forms_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_forms_2 = /** @type {((inputs?: Pc_Tut_Forms_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Forms_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_forms_2(inputs)
	return zh_pc_tut_forms_2(inputs)
});
export { pc_tut_forms_2 as "pc.tut.forms.2" }